import styled from "styled-components";
import { SvgProps } from "./types";

const Svg = styled.svg<SvgProps>`
  path {
    ${({ fill }) => fill && `fill: ${fill}`}
    fill-opacity: ${({ fillOpacity }) => fillOpacity || 1};
  }
`;

export default Svg;
